module.exports = __webpack_public_path__ + "static/media/DC_F_Fashion_Necchi_Blue-Orange.357088b5.png";